<template>
  <div class="obituary-more-comment-actions">
    <button
      class="btn icon obituary-more-comment-actions__button"
      type="button"
      :aria-label="texts.showMoreOptions"
      @click.prevent="toggleDropdown"
    >
      <svg aria-hidden="true" class="icon icon--fixed-width">
        <use href="#ellipsis-vertical" />
      </svg>
    </button>

    <!-- biome-ignore lint/a11y/useKeyWithClickEvents: Legacy -->
    <!-- biome-ignore lint/a11y/noNoninteractiveElementInteractions: Legacy -->
    <!-- biome-ignore lint/a11y/noStaticElementInteractions: Legacy -->
    <div
      class="obituary-more-comment-actions__overlay"
      v-if="showDropdown"
      @click.prevent="toggleDropdown"
    />

    <div
      class="obituary-more-comment-actions__dropdown"
      v-if="showDropdown"
      ref="dropdown"
      :style="dropdownStyle"
    >
      <div class="obituary-more-comment-actions__dropdown-header">
        <h4 v-text="texts.header" />
        <close-button :close-action="toggleDropdown" />
      </div>

      <button class="btn icon" type="button" @click.prevent="reportComment">
        <svg class="icon">
          <title>Question</title>
          <use href="#circle-exclamation" />
        </svg>
        <span v-text="texts.reportInappropriate" />
      </button>
    </div>
  </div>
</template>

<script>
  import CloseButton from "Components/CloseButton.vue";
  import { useScrollIntoView } from "Composables/useScrollIntoView";
  import { useIsMobile } from "Main/composables/useIsMobile";
  import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
  import { mapActions } from "vuex";

  export default {
    beforeUnmount() {
      if (this.showDropdown) {
        enableBodyScroll(this.$refs.dropdown);
      }
    },

    components: { CloseButton },

    data() {
      return {
        dropdownStyle: {},
        showDropdown: false,
        texts: lavendlaObituary.moreCommentActions,
      };
    },

    methods: {
      ...mapActions({
        report: "comments/reportObituaryComment",
      }),

      calculateDropdownPosition() {
        if (this.isMobile) {
          return {};
        }

        const card = this.$el.closest(
          ".obituary-timeline__card, .single-obituary-comment"
        );

        if (!card) {
          return {};
        }

        const cardRect = card.getBoundingClientRect();
        const isTimeline = card.classList.contains("obituary-timeline__card");
        const topOffset = isTimeline ? 8 : -70;
        const viewportHeight = window.innerHeight;
        const dropdownHeight = this.$refs.dropdown?.offsetHeight ?? 0;
        const desiredTop = cardRect.bottom + topOffset;
        const wouldOverflow =
          dropdownHeight > 0 && desiredTop + dropdownHeight > viewportHeight;
        const flippedTop = cardRect.top - dropdownHeight - Math.abs(topOffset);
        const top = wouldOverflow && flippedTop >= 0 ? flippedTop : desiredTop;

        return {
          bottom: "auto",
          left: `${cardRect.left}px`,
          position: "fixed",
          right: "auto",
          top: `${top}px`,
          width: `${cardRect.width}px`,
        };
      },

      reportComment() {
        // biome-ignore lint/suspicious/noAlert: Legacy
        const confirmed = confirm(this.texts.areYouSure);

        if (confirmed) {
          this.reportCommentAction();
        }

        this.toggleDropdown();
      },

      reportCommentAction() {
        const data = {
          id: this.comment.id,
        };

        this.report(data).catch((error) => {
          // biome-ignore lint/suspicious/noAlert: Legacy
          alert(error.serverMessage || this.texts.alert);
        });
      },

      toggleDropdown() {
        if (this.isMobile && !this.showDropdown) {
          this.scrollIntoViewAlignBottom(
            ".obituary-more-comment-actions",
            `#comment-${this.comment.id}`
          );
        }

        if (this.showDropdown) {
          enableBodyScroll(this.$refs.dropdown);
          this.showDropdown = false;
          this.dropdownStyle = {};
          return;
        }

        this.showDropdown = true;

        this.$nextTick(() => {
          this.dropdownStyle = this.calculateDropdownPosition();
          disableBodyScroll(this.$refs.dropdown);
        });
      },
    },
    name: "MoreCommentActions",

    props: {
      comment: {
        required: true,
        type: Object,
      },
    },

    setup() {
      const { isMobile, isTablet } = useIsMobile();
      const {
        scrollIntoView,
        scrollIntoViewCentered,
        scrollIntoViewAlignBottom,
      } = useScrollIntoView();
      return {
        isMobile,
        isTablet,
        scrollIntoView,
        scrollIntoViewAlignBottom,
        scrollIntoViewCentered,
      };
    },
  };
</script>
